/**
 * 앱 버전 정보를 반환하는 함수
 */
export const getVersionInfo = () => {
  return {
    version: __APP_VERSION__,
    buildTime: new Date(__BUILD_TIME__),
    isProduction: __BUILD_MODE__ === "production",
    buildMode: __BUILD_MODE__,
  }
}

/**
 * 콘솔에 버전 정보를 출력하는 함수
 */
export const logVersionInfo = () => {
  const { version, buildTime, buildMode } = getVersionInfo()

  console.log(`
    App Version: ${version}
    Build Time: ${buildTime.toLocaleString()}
    Mode: ${buildMode}
  `)
}
